<template>
  <div class="safe-center container-fluid">

    <div class="title">
      <span v-show="isModifyPwd">{{ $t('changePassword') }}</span>
      <span v-show="!isModifyPwd">{{ $t('setNewPassword') }}</span>
    </div>

    <transition name="notice">
      <div class="prompt-message" v-show="showSuccessNotice">
        <span class="glyphicon glyphicon-envelope pull-left"></span>
        <span>{{ successPromptMessage }}</span>
      </div>
    </transition>

    <div id="safe-center-content">
      <modify-password v-show="isModifyPwd" @doModify="doModifyPassword" class="modify-set-pwd"></modify-password>
      <setting-new-password v-show="!isModifyPwd" @settingNewPassword="settingNewPassword" class="modify-set-pwd"></setting-new-password>
    </div>

  </div>
</template>

<script>
  import Spinner from '../../components/Spinner.vue'
  import ModifyPassword from './ModifyPassword.vue'
  import locales from './lang.js'
  import SettingNewPassword from './setNewPassword/SetNewPassword.vue'

  export default {
    name: 'safe-center-view',
    components: {
      Spinner,
      ModifyPassword,
      SettingNewPassword
    },
    data: function () {
      return {
        successPromptMessage: '您的密码已修改成功',
        isModifyPwd: true,
        showSuccessNotice: false
      }
    },
    locales,
    created: function () {
      this.$store.state.user['need_set_password'] === false ? this.isModifyPwd = true : this.isModifyPwd = false
    },
    methods: {
      doModifyPassword: function (msg) {
        this.successPromptMessage = msg
        this.autoPrompt()
      },
      settingNewPassword: function (msg) {
        this.successPromptMessage = msg
        this.autoPrompt()
      },
      autoPrompt() {
        this.showSuccessNotice = !this.showSuccessNotice
        setTimeout(() => {
          this.showSuccessNotice = false
        }, 5)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  .notice-enter-active, .notice-leave-active {
    animation: copy 2s;
  }

  @keyframes notice {
    0% {
      opacity: 0
    }
    100% {
      opacity: 1
    }
  }

  .safe-center {
    width: 100%;
    border: 1px solid rgba(224,215,227,1);
    border-radius: 8px;
    @media screen and (max-width: 767px) {
      border-radius: 5px;
    }
  }

  .title {
    padding: 0 .16rem;
    border-bottom: .01rem solid rgba(224,215,227,1);
    line-height: .48rem;
    height: .48rem;
    display: block;
    span {
      line-height: .48rem;
      height: .48rem;
      border-bottom: .01rem solid transparent;
      color: #111;
      display: inline-block;
      font-size: .16rem;
    }
    @media screen and (max-width: 767px) {
      line-height: .44rem;
      height: .44rem;
      span {
        line-height: .44rem;
        height: .44rem;
        font-size: .14rem;
      }
    }
  }

  .prompt-message {
    color: $success-color;
    max-width: 3rem;
    margin: 0 auto;
    padding-top: .2rem;
    line-height: .2rem;
    .glyphicon {
      line-height: .2rem;
    }
    .glyphicon-envelope {
      margin-right: .2rem;
    }
  }

  #safe-center-content {
    height: 4.9rem;
    display: table;
    width: 100%;
    max-width: 3rem;
    table-layout: fixed;
    margin: auto;
    div.modify-set-pwd {
      display: table-cell;
      width: 100%;
      vertical-align: middle;
      text-align: center;
    }
    @media (max-width: 767px) {
      height: auto;
      padding-top: .4rem;
    }
  }
</style>



// WEBPACK FOOTER //
// SafeCenter.vue?5a33b488